import ApiService from '../_shared/api/apiService';
import Singleton from '../Singleton';

export default class TodoService extends Singleton<TodoService> {
  /**
   * Returns an array of the user's todos
   */
  public getTodos = async () => {
    const client = await ApiService();

    const todoListResponse = await client.apis.todo.listTodos();
    return todoListResponse?.body?.todos;
  };
}
